import { AxiosApiBase } from './axiosApiBase';
import { KycResponse } from '../models/dtos/kyc';

export class KycApi extends AxiosApiBase {
  async getKycStatus(borrowerId: number): Promise<KycResponse> {
    return await this.get<KycResponse>(`/api/v1/Kyc?borrowerId=${borrowerId}`);
  }
}
